import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classnames from 'classnames';
import React__default from 'react';
import Input from '../../../Input/index.js';
import ColumnManagerSearchInput from './ColumnManagerSearchInput.js';
import { useColumnManager } from './context/ColumnManagerContext.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ColumnManagerSearch = function ColumnManagerSearch(_ref) {
  var onChange = _ref.onChange,
    className = _ref.className;
  var _useColumnManager = useColumnManager(),
    columnDefs = _useColumnManager.columnDefs,
    updateColumnDefs = _useColumnManager.updateColumnDefs;
  var finalClasses = classnames('C-ColumnManager__Search', className);
  var indeterminate = columnDefs.some(function (c) {
    return !c.isVisible;
  });
  var checked = columnDefs.some(function (c) {
    return c.isVisible;
  });
  var handleChecked = function handleChecked() {
    updateColumnDefs(function (prev) {
      return prev.map(function (c) {
        var val = indeterminate ? true : !checked;
        return _objectSpread(_objectSpread({}, c), {}, {
          isVisible: c.isFiltered ? val : c.isVisible
        });
      });
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: finalClasses
  }, /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    indeterminate: indeterminate,
    checked: checked,
    onChange: handleChecked,
    "aria-label": "".concat(checked ? 'hide' : 'show', " all columns")
  }), /*#__PURE__*/React__default.createElement(ColumnManagerSearchInput, {
    onChange: onChange
  }));
};

export { ColumnManagerSearch as default };
